module.exports = __webpack_public_path__ + "img/steigler_dani.a761f671.jpg";